import { render, staticRenderFns } from "./ThemeWidget.vue?vue&type=template&id=03fef5f4&scoped=true&"
import script from "./ThemeWidget.vue?vue&type=script&lang=js&"
export * from "./ThemeWidget.vue?vue&type=script&lang=js&"
import style0 from "./ThemeWidget.vue?vue&type=style&index=0&id=03fef5f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fef5f4",
  null
  
)

export default component.exports